import colors from 'styles/colors'
import { typography } from 'styles/typography'

const title = {
  ...typography.fontSemiBold,
  fontSize: 14,
  lineHeight: '10px',
  color: colors.lightBlack
}

const address = {
  ...typography.font,
  maxWidth: '70%',
  fontSize: 16,
  lineHeight: '17px',
  color: colors.darkGray
}

const RIGHT_COLUMN_PADDING_LEFT = 28

export const defaultStyles = {
  container: {
    width: '100%',
    borderTop: `1px solid ${colors.pixelWhite}`,
    backgroundColor: colors.white
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 15,
    marginBottom: 7
  },
  firstTitle: {
    ...title,
    width: '75%'
  },
  secondTitle: {
    ...title,
    paddingLeft: RIGHT_COLUMN_PADDING_LEFT,
    width: '25%'
  },
  dataContainer: {
    display: 'flex',
    marginBottom: 20
  },
  locationsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '75%'
  },
  phoneContainer: {
    display: 'flex',
    width: '25%',
    paddingLeft: RIGHT_COLUMN_PADDING_LEFT
  },
  address: {
    ...address
  },
  addressLink: {
    ...address,
    marginLeft: 10,
    color: colors.primary
  },
  phone: {
    ...address,
    color: colors.primary
  },
  border: {
    paddingTop: 10,
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderTopColor: colors.pixelWhite
  }
}
